import { useEffect, useState } from "react";
import { _Inbox } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import "./ResumeImp.css";

interface Props {
    IDProcedureImp: number;
}

export const ResumeImp = ({ IDProcedureImp }: Props) => {

    const { instance } = useDataBean(_Inbox);
    const [process, setProcess] = useState<any>([])

    useEffect(() => {
        getInfo()
    }, [IDProcedureImp])

    const getInfo = () => {
        if (IDProcedureImp > 0)
            instance.getResumeBpmByImp(IDProcedureImp)
                .then((resp) => {
                    if(resp.ResumeList)
                    {                        
                        setProcess(resp.ResumeList);
                    }
                })
                .catch(err => console.error("Error en actualizar la tabla", err));
    };

    const formatFecha = (fechaStr) => {
        const fecha = new Date(fechaStr.replace("COT", "GMT"));

        return fecha.toLocaleString("es-CO", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
        });
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <table className="table table-striped">
                    <tbody>
                        {process.length > 0 ? (
                            process.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="row">
                                            <div className="col-md-12 d-flex justify-content-between mb-4">
                                                <b>{item.DataBeanProperties.Employee}</b>
                                                <b>{item.DataBeanProperties.Since}</b>
                                            </div>
                                            <div className="col-md-12 custom-scroll" style={{ maxWidth: "50vw", overflowX: "auto" }}>
                                                <p dangerouslySetInnerHTML={{ __html: item.DataBeanProperties.Resume }} />
                                            </div>

                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <p>No hay registros disponibles</p>
                        )}
                    </tbody>
                </table>
            </div>
        </div>

    )
}